import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdHandlers = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdHandlerListDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      mrdName: payload.params.mrdName,
    },
  });
  return axios.get(serviceURL, {
    params: {
      active: payload.params.active,
    },
  });
};

export const apiFetchMrdDeviceListByCountry = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdDeviceListByCountry',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      filter: payload?.params?.filter || 'active',
    },
  });
  return axios.get(serviceURL);
};

export const apiFetchAllHandlers = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllHandlersDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiAddHandler = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getAllHandlersDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, { handlerName: payload });
};
